const GOOGLE_MAP_KEY = 'AIzaSyACo2ol1GMeAOlTekBpbTrT_4gZIbXVwGA';

module.exports = GOOGLE_MAP_KEY;
